// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

export { default } from './Alert';



// WEBPACK FOOTER //
// ./components/Alert/index.js